import map from 'ramda/src/map'
import memoizeWith from 'ramda/src/memoizeWith'
import propOr from 'ramda/src/propOr'
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrAssignees } = responseLenses

export default memoizeWith(
	(state, props) => JSON.stringify(pathOrAssignees([1], getRecordSelector(state, props))),
	(state, props) => map(
		assignee => propOr('https://placehold.jp/24/3d4070/ffffff/28x28.png?text=assignee', 'image', assignee),
		pathOrAssignees([1], getRecordSelector(state, props)),
	),
)
